import Form from '../Form';
import SVG from '../SVG';
import * as S from './styles';

export interface TableControlProps {
  currentPage: number;
  itemsPerPage: number;
  totalOfItems: number;
  setPage: (number: number) => void;
  setItemsPerPage: (number: number) => void;
}

function TableControl({
  currentPage = 1,
  itemsPerPage = 0,
  totalOfItems = 0,
  setPage,
  setItemsPerPage,
}: TableControlProps) {
  const pageItems = [
    {
      id: '1',
      name: '50',
    },
    {
      id: '2',
      name: '100',
    },
    {
      id: '3',
      name: '250',
    },
  ];

  const numberOfPages = Math.ceil(totalOfItems / itemsPerPage);

  const hasNextPage = currentPage < numberOfPages;
  const hasPrevPage = currentPage > 1;

  const nextPage = () => {
    if (hasNextPage) setPage(Math.min(currentPage + 1, numberOfPages));
  };

  const prevPage = () => {
    if (hasPrevPage) setPage(Math.max(currentPage - 1, 1));
  };

  const firstPage = () => {
    if (hasPrevPage) setPage(1);
  };

  const lastPage = () => {
    if (hasNextPage) setPage(numberOfPages);
  };

  const itemsOffset = (currentPage - 1) * itemsPerPage;

  const displayMessage = ` ${itemsOffset + 1} - ${Math.min(
    itemsOffset + itemsPerPage,
    totalOfItems,
  )} de ${totalOfItems}`;

  return (
    <S.TableControlContainer >
      <S.TableControlPageInputContainer>
          <S.TableControlPageInputLabel>
            <span
              style={{
                fontSize: '17px',
                marginLeft: '10px',
                color: '#364856',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              Items por página:
            </span>
          </S.TableControlPageInputLabel>
        <S.TableControlPageInput>
          <Form.Input.Dropdown
            backgroundColor="white"
            listDirection="up"
            errorMessage={false}
            items={pageItems}
            fontSize={16}
            value={`${itemsPerPage}`}
            onSelected={({ name }) => {
              setItemsPerPage(+name);
            }}
          />
        </S.TableControlPageInput>
      </S.TableControlPageInputContainer>
        <span
          style={{
            fontSize: '17px',
            marginLeft: '10px',
            color: '#364856',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {displayMessage}
        </span>
      <S.TableControlArrowsContainer>
        <S.TableControlArrowsIconContainer
          onClick={firstPage}
          active={hasPrevPage}
        >
          <SVG.Icon.SVGIconArrowDuplo
            width={20}
            height={20}
            color={hasPrevPage ? '#11465D' : '#a7a7a7'}
          />
        </S.TableControlArrowsIconContainer>
        <S.TableControlArrowsIconContainer
          onClick={prevPage}
          active={hasPrevPage}
        >
          <SVG.Icon.SVGIconBackSet
            width={20}
            height={20}
            color={hasPrevPage ? '#11465D' : '#a7a7a7'}
          />
        </S.TableControlArrowsIconContainer>
        <S.TableControlArrowsIconContainer
          onClick={nextPage}
          active={hasNextPage}
        >
          <SVG.Icon.SVGIconReturnRightSet
            width={20}
            height={20}
            color={hasNextPage ? '#11465D' : '#a7a7a7'}
          />
        </S.TableControlArrowsIconContainer>
        <S.TableControlArrowsIconContainer
          onClick={lastPage}
          active={hasNextPage}
        >
          <SVG.Icon.SVGIconArrowRightDuplo
            width={20}
            height={20}
            color={hasNextPage ? '#11465D' : '#a7a7a7'}
          />
        </S.TableControlArrowsIconContainer>
      </S.TableControlArrowsContainer>
    </S.TableControlContainer>
  );
}
export default TableControl;
